import React, { useState } from 'react'
import { useTranslate } from './TranslationText';
import PillBtn from './PillBtn';
const BaseURL = process.env.REACT_APP_BASE_URL;

export default function FilterButton({ onClick, isStudBookPage = false }) {
  const [isHovered, setIsHovered] = useState(false);

  const { translate } = useTranslate();
  return (
    <PillBtn
      isSubmitBtn
      imgURL={
        !isHovered
          ? `/assets/img/filterWhite.png`
          : `/assets/img/filter.png`
      }
      onMouseLeave={() => setIsHovered(false)}
      onMouseOver={() => setIsHovered(true)}
      onClick={onClick}
      isWithClass
      isNoMargin
      isNoPadding
      classes={`${isStudBookPage ? 'd-inline-block' : 'd-block'} btn-danger`}
      text={translate('web.filter', 'Show Filter')}
    />
  )
}
